export default __webpack_public_path__ + "static/media/close-red.552e389d.svg";